module.exports = __webpack_public_path__ + "static/media/fleetCompanies.1861b8bb.svg";